import { controls,grouped } from "../controls";
const cpbts = {
label: "Cash Payments",
pageLabel: "Cash Payments",starting: true,url: "autogen",
formActions: { edit: { allow: false },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Account Id",width:'col-sm-3'}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "account_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Amount",width:'col-sm-3'}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "amount",maxlength:21}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Charges",width:'col-sm-3'}),
...controls.floatOnly({ tab: "filter",  placeHolder: "", name: "charges",maxlength:21}),
...controls.displayText({ tab: "filter",  label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Instrument Number",width:'col-sm-3'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "instrument_number",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "filter", label: "Instrument Date",target: "instrument_date",width:'col-sm-3'}),
...controls.magicDate({ tab: "filter", name: "instrument_date", dateType: "ontype" }),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Particulars",width:'col-sm-5'}),
...controls.text({ tab: "filter",  placeHolder: "", name: "particulars",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Cash Payment Batch Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "cash_payment_batch_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Account",star:true}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code",width:'col-sm-3', name: "account_code", isRequired:true,fastpath:"accounts" ,isReadOnly:"edit" }),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display",width:"col-sm-7"}),
...controls.displayText({ tab: "general", label: "Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "amount",width:'col-sm-3',maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "Charges"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "charges",width:'col-sm-3',maxlength:18 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "Instrument Number",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "instrument_number",isRequired:false,width:'col-sm-3',maxlength:10 ,isReadOnly:"edit" }),
...controls.magicDateLabel({ tab: "general", label: "Instrument Date",target: "instrument_date",star:true}),
...controls.magicDate({ tab: "general", name: "instrument_date", dateType: "ontype",isRequired:true,width:'col-sm-3' ,isReadOnly:"edit"  }),
...controls.displayText({ tab: "general", label: "Particulars",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "particulars",isRequired:true,width:'col-sm-5',maxlength:10 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: "Cpb",star:true}),
...controls.oc({ tab: "general", c: "CashPaymentBatch", placeHolder: "Cpb Code", name: "cpb_code", isRequired:true,fastpath:"cpb" ,isReadOnly:"edit" }),
...controls.showData({ tab: "general", displaytype: "capital", data: "cpb_display"}),
]
,history:{
perPage: 10,
reportHeader: "Cash Payments",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Account Id",accessor: "account_id",},
{Header: "Amount",accessor: "amount",},
{Header: "Charges",accessor: "charges",},
{Header: "Instrument Number",accessor: "instrument_number",},
{Header: "Instrument Date",accessor: "instrument_date",type:'date'},
{Header: "Particulars",accessor: "particulars",},
{Header: "Cash Payment Batch Id",accessor: "cash_payment_batch_id",},
]}};
export default cpbts;